import ControlesController from './controles.controller';

export default {
    template: require('./controles.html'),
    controller: ControlesController
};
